<style lang="scss" scoped>
.login-wrapper{
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 3;
  &-content{
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width:410px;
    height:360px;
    background:rgba(255,255,255,1);
    border-radius:8px;
    box-sizing: border-box;
    padding: 0 24px 24px 24px;
    /* @media screen and (max-width: 1500px ) {
      transform: scale(1.5) translate(-80%, -40%);
      
    } */
    &-closebtn{
      width: 16px;
      height: 16px;
      position: absolute;
      right: 12px;
      top: 12px;
      background: url('./../assets/img/group7.svg') no-repeat;
      background-size: cover;
      cursor: pointer;
    }
    &-title{
      font-size:20px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(15,22,43,1);
      line-height:28px;
      margin-top: 36px;
    }
    input{
      width:304px;
      height:46px;
      background:rgba(247,249,250,1);
      border-radius:4px;
      font-size:16px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(15,22,43,1);
      line-height:22px;
      box-sizing: border-box;
      padding: 13px 12px;
      outline: none;
      border: none;
      &:focus{
        outline: none; 
        border: 1px solid #1985ff;
      }
    }
    &-username{
      margin-top: 38px;
    }
    &-password{
      margin-top: 12px;
    }
    &-btn{
      width:306px;
      height:50px;
      border-radius:4px;
      background:rgba(163,206,255,1);
      border: none;
      outline: none;
      margin-top: 30px;
      font-size:16px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(255,255,255,1);
      line-height:22px;
      margin-bottom: 8px;
      cursor: pointer;
    }
    .btn-cli{
      background:rgba(25,133,255,1);
    }
    a{
      font-size:13px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(127,127,127,1);
      line-height:18px;
    }
    &-signin{
      position: absolute;
      left: 52px;
      top: 298px;
    }
    &-findpw{
      position: absolute;
      right: 52px;
      top: 298px;
    }
    @media screen and (max-width: 1500px ) {
      position: absolute;
      z-index: 2;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width:420px;
      height: 360px;
      background:rgba(255,255,255,1);
      border-radius:8px;
      box-sizing: border-box;
      padding: 0 36px 32px 36px;
      /* @media screen and (max-width: 1500px ) {
        transform: scale(1.5) translate(-80%, -40%);

      } */
      &-closebtn{
        width: 20px;
        height: 20px;
        position: absolute;
        right: 12px;
        top: 12px;
        background: url('./../assets/img/group7.svg') no-repeat;
        background-size: cover;
        cursor: pointer;
      }
      &-title{
        font-size:22px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(15,22,43,1);
        line-height:28px;
        margin-top: 36px;
      }
      input{
        width:342px;
        height:46px;
        background:rgba(247,249,250,1);
        border-radius:4px;
        font-size:16px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(15,22,43,1);
        line-height:22px;
        box-sizing: border-box;
        padding: 13px 12px;
        outline: none;
        border: none;
        &:focus{
          outline: none; 
          border: 1px solid #1985ff;
        }
      }
      &-username{
        margin-top: 38px;
      }
      &-password{
        margin-top: 20px;
      }
      &-btn{
        width:342px;
        height:50px;
        border-radius:4px;
        background:rgba(163,206,255,1);
        border: none;
        outline: none;
        margin-top: 30px;
        font-size:16px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:22px;
        margin-bottom: 8px;
        cursor: pointer;
      }
      .btn-cli{
        background:rgba(25,133,255,1);
      }
      a{
        font-size:13px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(127,127,127,1);
        line-height:18px;
      }
      &-signin{
        position: absolute;
        left: 52px;
        top: 298px;
      }
      &-findpw{
        position: absolute;
        right: 52px;
        top: 298px;
      }
    }
  }
  .mask{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    background:rgba(0,0,0,1);
    opacity:0.6009;
  }
}
</style>

<template>
  <div class="login-wrapper" v-show="showLoginBox">
    <div class="login-wrapper-content">
      <span class="login-wrapper-content-closebtn" @click="showLoginBox = false"></span>
      <p class="login-wrapper-content-title">登录</p>
      <input v-model="username" class="login-wrapper-content-username" autofocus="autofocus" type="text" placeholder="用户名/邮箱/手机">
      <input v-model="password" class="login-wrapper-content-password"  @keyup.enter="login" type="password" placeholder="登录密码">
      <button :class="{'login-wrapper-content-btn': true, 'btn-cli': username && password}" ref="loginBtn" @click="login">登录</button>
      <a  target="_blank" class="login-wrapper-content-signin" href="https://passport.feng.com/?r=user/register&sso%5Bjump%5D=http%3A%2F%2Fwww.feng.com%2F&sso%5Bname%5D=威锋论坛&sso%5Bapps%5D=2&sso%5Bverify%5D=73727ddd858771ecfb2c1cf514e34056">注册</a>
      <a  target="_blank" class="login-wrapper-content-findpw" href="https://passport.feng.com/index.php?r=pwd/forgetPassword">找回密码</a>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showLoginBox: false,
      username: '',
      password: '',
    }
  },
  methods: {
    login() {
      if(this.username && this.password){
        this.$refs.loginBtn.disabled = 'disabled';
        this.$http.login({username: this.username, password: this.password}).then((res) => {
          this.$refs.loginBtn.disabled = '';
          if(res.code != 0){
            this.password = '';
            this.$toast({
              message: res.info,
              duration: 2000
            });
          } else {
            this.password = '';
            this.showLoginBox = false;
            localStorage.setItem('token', res.data.accessToken);
            localStorage.setItem('userIcon', res.data.userIcon);
            localStorage.setItem('userHome', res.data.userHome);
            localStorage.setItem('userName', res.data.userName);
            localStorage.setItem('isLogin', 'true');
            this.$bus.emit('userInfo');
            this.$toast({
              message: res.info,
              duration: 1500,
              type: 'success'
            })
          }
          return res;
        }).then((res) => {
          this.$http.userLotteryCount({actCode: this.$str('actCode')},{headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}}).then((data) => {
            this.$bus.emit('setLotteryCount', data.data.leftLotteryCount);
          });
        });
      }
    }
  },
  mounted() {
    this.$bus.on('showLoginBox', () => {
      this.showLoginBox = true;
      this.$http.actStatus({actCode: this.$str('actCode')}).then((res) => {
        if(res.data.activityStatus === 'live'){
          localStorage.setItem('isLive', true);
          localStorage.setItem('isWait', false);
          localStorage.setItem('isEnd', false);
        } else if(res.data.activityStatus === 'wait') {
          localStorage.setItem('isWait', true);
          localStorage.setItem('isLive', false);
          localStorage.setItem('isEnd', false);
        } else if(res.data.activityStatus === 'end') {
          localStorage.setItem('isEnd', true);
          localStorage.setItem('isLive', false);
          localStorage.setItem('isWait', false);
        }
      })
    })
    //解决滑动穿透
    const oLogin = document.querySelector('.login-wrapper');
    oLogin.addEventListener('touchmove', (e) => {
      e.preventDefault();
    }, false);
  }
}
</script>



// WEBPACK FOOTER //
// src/blocks/Login.vue